export default __webpack_public_path__ + "static/media/Whispersilk Drape.656e1a75.jpg";